<template>
  <Teleport to="body">
    <Transition name="modal">
      <div
        v-if="modelValue"
        class="fixed z-50 inset-0 flex items-center justify-center"
        role="dialog"
        aria-modal="true">
        <div class="bg-black/50 absolute inset-0" @click="$emit('update:modelValue', false)" />
        <div class="max-h-[90vh] relative flex flex-col mx-4 w-full max-w-lg bg-white rounded-lg shadow-xl" @click.stop>
          <div class="flex items-center justify-between p-4 border-b border-gray-200">
            <slot name="header">
              <h3 class="text-lg font-semibold">
                {{ title }}
              </h3>
            </slot>
            <button
              type="button"
              class="text-gray-400 hover:text-gray-700 text-2xl leading-none"
              @click="$emit('update:modelValue', false)"
              aria-label="Close">
              ×
            </button>
          </div>
          <div class="flex-1 p-4 overflow-y-auto">
            <slot />
          </div>
          <div v-if="$slots.footer" class="flex gap-2 items-center justify-end p-4 border-t border-gray-200">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
    props: {
        modelValue: { type: Boolean, default: false },
        title: { type: String, default: '' },
    },
    emits: ['update:modelValue'],
    watch: {
        modelValue (val) {
            val ? document.addEventListener('keydown', this.onEsc) : document.removeEventListener('keydown', this.onEsc)
        },
    },
    methods: {
        onEsc (e) {
            if (e.key === 'Escape') this.$emit('update:modelValue', false)
        },
    },
    beforeUnmount () {
        document.removeEventListener('keydown', this.onEsc)
    },
}
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
